import { createRandom, type Random } from "../core/random.js";

/**
 * Aleatoriedad de la carrera, sin estado que guardar.
 *
 * Cada decision pide su propio generador a partir de la semilla de la carrera
 * y de DONDE se toma (temporada, jornada, que se decide). Asi no hay que
 * guardar el estado de ningun generador entre sesiones, y rejugar una jornada
 * en un test da exactamente lo mismo.
 */
export function hashSeed(...parts: ReadonlyArray<number | string>): number {
  // FNV-1a de 32 bits sobre las partes unidas: sencillo y estable.
  let h = 0x811c9dc5;
  const text = parts.join("|");
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function rngFor(...parts: ReadonlyArray<number | string>): Random {
  return createRandom(hashSeed(...parts));
}

export function pick<T>(random: Random, list: readonly T[]): T {
  return list[Math.floor(random() * list.length) % list.length]!;
}

export function shuffle<T>(random: Random, list: readonly T[]): T[] {
  const out = [...list];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}

/** Entero en [min, max]. */
export function between(random: Random, min: number, max: number): number {
  return min + Math.floor(random() * (max - min + 1));
}

/** Goles de un equipo: Poisson, como en el futbol de verdad. */
export function poisson(random: Random, lambda: number): number {
  const limit = Math.exp(-lambda);
  let k = 0;
  let p = random();
  while (p > limit && k < 15) {
    k++;
    p *= random();
  }
  return k;
}
